import Svg, { Circle, Path } from 'react-native-svg';

/**
 * Lucide's hat-glasses (ISC licensed) redrawn so it can fill in like the heart and the bookmark
 * beside it. Lucide's own icon is stroke-only, so filling it blindly would paint the glasses
 * solid. Here only the crown takes the fill. The brim, bridge and lenses stay strokes in the
 * icon color, which keeps them readable against the surface the glasses sit on.
 */
const CROWN =
  'm19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11';

const BRIM = 'M2 11h20';

const BRIDGE = 'M14 18a2 2 0 0 0-4 0';

export function AnonymousHatIcon({
  color,
  surface,
  filled,
  size = 24,
}: {
  color: string;
  /** The color behind the icon, which the lenses are filled with so the crown fill never bleeds in. */
  surface: string;
  filled: boolean;
  size?: number;
}) {
  const stroke = {
    stroke: color,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  } as const;

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path d={CROWN} fill={filled ? color : 'none'} {...stroke} />
      <Path d={BRIM} {...stroke} />
      <Path d={BRIDGE} {...stroke} />
      <Circle cx={17} cy={18} r={3} fill={filled ? surface : 'none'} {...stroke} />
      <Circle cx={7} cy={18} r={3} fill={filled ? surface : 'none'} {...stroke} />
    </Svg>
  );
}
